"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Refresh = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Refresh = function Refresh() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.421 11.893l.218.218a.547.547 0 010 .776l-3.851 3.866a.556.556 0 01-.775 0L.161 12.887a.546.546 0 010-.776l.219-.218a.534.534 0 01.392-.164h2.5a8.74 8.74 0 014.367-7.56 8.721 8.721 0 018.726.002.568.568 0 01.283.404.547.547 0 01-.153.459l-.807.808a.556.556 0 01-.644.098A6.356 6.356 0 0012 5.176a6.55 6.55 0 00-6.547 6.553h2.575a.534.534 0 01.393.164zm15.2-.328l.218-.218a.546.546 0 000-.776l-3.852-3.866a.556.556 0 00-.775 0l-3.851 3.866a.546.546 0 000 .776l.218.218a.534.534 0 00.393.164h2.575c0 1.738-.69 3.405-1.918 4.634A6.543 6.543 0 0112 18.283a6.477 6.477 0 01-3.033-.754.545.545 0 00-.644.098l-.797.797a.546.546 0 00-.152.46.568.568 0 00.262.403 8.721 8.721 0 008.725.003 8.74 8.74 0 004.368-7.561h2.499a.534.534 0 00.392-.164z",
    clipRule: "evenodd"
  });
};

exports.Refresh = Refresh;